import { runStreamsPage } from './streams_page.jsx'
import { runDvbAdaptersPage } from './dvb_adapters_page.jsx'

window.runStreamsPage = runStreamsPage;
window.runDvbAdaptersPage = runDvbAdaptersPage;
